import React from "react";
import ReactDOM from "react-dom";
import styles from "./PricingPlans.module.scss";
import { ReactComponent as GrailIcon } from '../../../../assets/icons/grail_pricing.svg';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/calendar_pricing.svg';
import { ReactComponent as ClockIcon } from '../../../../assets/icons/clock_pricing.svg';

interface PlanDetails {
  price: number;
  currency: string;
  options: {
    access_hours: null | string;
    capacity: null | number;
  };
}

const PricingPlans = () => {
  const portal = document.getElementById("pricing_plans") as HTMLDivElement;

  const [selectedOption, setSelectedOption] = React.useState<any>(null);
  const [data, setData] = React.useState({
    reformattedWorkspaces: {},
    reformattedDurations: {},
  });
  const [currentDataVariant, setCurrentDataVariant] = React.useState<any>({});

  const [mostExpensive, setMostExpensive] = React.useState(0);

  // import .ts calculations only in case we have #pricing_plans so as not to break other pages
  React.useEffect(() => {
    if (portal) {
      import("./pricingPlansData")
        .then((module) => {
          setData({
            reformattedWorkspaces: module.reformattedWorkspaces,
            reformattedDurations: module.reformattedDurations,
          });
        })
        .catch((err) => console.log(err));
    }
  }, [portal]);

  React.useEffect(() => {
    setCurrentDataVariant(data.reformattedWorkspaces)
  }, [data]);

  React.useEffect(() => {
    setSelectedOption(Object.keys(currentDataVariant)[1])
  }, [currentDataVariant]);

  React.useEffect(() => {
    if (selectedOption && currentDataVariant[selectedOption]) {
        const prices = Object.values(currentDataVariant[selectedOption])
          .filter((details: PlanDetails) => typeof details.price === 'number')
          .map((details: PlanDetails) => details.price);

        setMostExpensive(Math.max(...prices));
    }
}, [currentDataVariant, selectedOption]);

  if (!portal) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={styles.container}>
      <h2>Pricing Plans</h2>

      <div className={styles.buttons_container}>
        <div className={styles.buttons_content}>
          {Object.keys(currentDataVariant).map((option) => (
            <button
              className={`${styles.optionButton} ${
                selectedOption === option ? styles.active : ""
              }`}
              onClick={() => setSelectedOption(option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.planGrid}>
        {Object.keys(currentDataVariant).includes(selectedOption) &&
          (function() {
            let isFirstMostExpensive = true;
            return Object.entries(currentDataVariant[selectedOption]).map(
              ([plan, details]: [string, PlanDetails], index) => {
                //const nonNullOptions = Object.entries(details.options).filter(([_, value]) => value !== null);
                const isMostExpensive = details.price === mostExpensive;
                const isTaggedPopular = isMostExpensive && isFirstMostExpensive;
                isFirstMostExpensive = isTaggedPopular ? false : isFirstMostExpensive;

                const planClass = `${details.currency ? styles.plan : `${styles.plan} ${styles.not_available}`}${isTaggedPopular ? ' ' + styles.popular : ''}`;

                return (
                  <div className={planClass} key={index}>
                    {plan === "Daily" && <ClockIcon className={styles.pricing_icon}></ClockIcon>}
                    {plan === "Monthly" && <CalendarIcon className={styles.pricing_icon}></CalendarIcon>}
                    {plan === "Annually" && <GrailIcon className={styles.pricing_icon}></GrailIcon>}
                    <h3>{plan}</h3>
                    <p>{`${details.currency}${details.price}`}</p>
                    <span>price / person {plan === "Annually" && '/ month'}</span>
                    {/*{details.options &&
                      Object.entries(details.options).filter(([_, value]) => value !== null).length > 0 && (
                        <>
                          <hr />
                          <ul>
                            {nonNullOptions.map(([key, value]) => (
                              <li key={key}>{`${
                                key.split("_")[0]
                              }: ${value?.toString().toLowerCase()}`}</li>
                            ))}
                          </ul>
                        </>
                      )}*/}
                  </div>
                );
              }
            )
          }())}
      </div>
    </div>,
    portal
  );
};

export default PricingPlans;
